/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import Textfield from "@react/react-spectrum/Textfield";
import { isMac } from "dc-preview-utils/src/Utils/DeviceUtils";
import CopyTextDialogCSS from "./CopyTextDialog.css";

const Dialog = require("@react/react-spectrum/Dialog").default;

class CopyTextDialog extends Component {
  selectContent(event) {
    event.target.select();
  }

  render() {
    const formatMessage = this.props.intl.formatMessage;
    let id = "dialog.copyText.windows.text";
    if (isMac()) {
      id = "dialog.copyText.mac.text";
    }

    return (
      <Dialog
        onClose={this.props.cancelDialog}
        title={formatMessage({ id: "dialog.copyText.title" })}
        confirmLabel={formatMessage({ id: "common.ok" })}
        autoFocusButton="confirm"
      >
        <p>{formatMessage({ id })}</p>
        <Textfield
          placeholder=""
          autoFocus
          value={this.props.value}
          readOnly="true"
          className={CopyTextDialogCSS.CopyTextDialog}
          onClick={this.selectContent}
          onFocus={this.selectContent}
        />
      </Dialog>
    );
  }
}

export { CopyTextDialog };
